<template>
  <div class="bg-fullscreen"
       :style="{'background-image': 'url(' + require('@/assets/event_owner/juventus/calendar-bg_low.jpg') + ')'}">
    <ModalCalendar :events="events"/>
  </div>
</template>

<script>
    import ModalCalendar from '@/components/ModalCalendar';
    import EventService from "@/services/Event"

    export default {
        components: {
            ModalCalendar
        },

        data () {
            return {
              events: []
            }
        },

        mounted() {
            EventService.listCalendarEvents().then(response => {
              this.events = response.data.results.map(i => {
                let event_name = i.name.replace(/\d{2,4}(\s*\/\s*\d{2,4})?/g,'')
                return {
                  start_at: new Date(i.start_at),
                  info: 'Serie A - 20:45',
                  title: event_name.split('-')[0],
                  subtitle: event_name.split('-')[1],
                  gallery_url: i.gallery_url
                }
              })
            })
          .finally(() => {
            this.$bvModal.show('modal-calendar')
          })
        }
    }
</script>

<style lang="scss">
/* Override background color opacity and remove blur */
.modal-backdrop {
  background-color: rgba(#000000, 0.3) !important;
  backdrop-filter: saturate(150%) !important;
}
</style>
